module.exports = __webpack_public_path__ + "static/img/GYWM-22.b6cf041.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/aboutUs/GYWM-22.jpg
// module id = MN6q
// module chunks = 1